import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import RoleDrawer from "components/drawer/RoleDrawer";
import MainDrawer from "components/drawer/MainDrawer";
import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";

const RoleTable = ({ roledata, hideDelete, hideEdit }) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();

  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <MainDrawer>
        <RoleDrawer id={serviceId} />
      </MainDrawer>

      <TableBody>
        {roledata?.slice(0).map((data, index) => (
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">{index + 1}</TableCell>

            <TableCell className="text-center text-xs">{data.name}</TableCell>

            <TableCell>
              <div className="flex justify-center">
                <EditDeleteButton
                  title={data.name}
                  id={data.id_profile}
                  handleUpdate={handleUpdate}
                  handleModalOpen={handleModalOpen}
                  hideEdit={hideEdit}
                  hideDelete={hideDelete}
                />
              </div>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default RoleTable;
